export enum OperationBenefitEnumFR {
  PEA = 'PEA',
  IR = 'IR',
  RENDEMENT = 'RENDEMENT',
  APPORT_CESSION = 'APPORT_CESSION',
}

export enum OperationBenefitEnum {
  SHARE_SAVINGS_PLAN = 'SHARE_SAVINGS_PLAN',
  INCOME_TAX = 'INCOME_TAX',
  RETURN = 'RETURN',
  CONTRIBUTION_CESSION = 'CONTRIBUTION_CESSION',
}

export const getOperationBenefitFromFR = (e: OperationBenefitEnumFR): OperationBenefitEnum => {
  switch (e) {
    case OperationBenefitEnumFR.PEA:
      return OperationBenefitEnum.SHARE_SAVINGS_PLAN;
    case OperationBenefitEnumFR.IR:
      return OperationBenefitEnum.INCOME_TAX;
    case OperationBenefitEnumFR.RENDEMENT:
      return OperationBenefitEnum.RETURN;
    case OperationBenefitEnumFR.APPORT_CESSION:
      return OperationBenefitEnum.CONTRIBUTION_CESSION;
  }
};

export const getOperationBenefitFromEN = (e: OperationBenefitEnum): OperationBenefitEnumFR => {
  switch (e) {
    case OperationBenefitEnum.SHARE_SAVINGS_PLAN:
      return OperationBenefitEnumFR.PEA;
    case OperationBenefitEnum.INCOME_TAX:
      return OperationBenefitEnumFR.IR;
    case OperationBenefitEnum.RETURN:
      return OperationBenefitEnumFR.RENDEMENT;
    case OperationBenefitEnum.CONTRIBUTION_CESSION:
      return OperationBenefitEnumFR.APPORT_CESSION;
  }
};

export const getOperationBenefitArrayFromFR = (a: OperationBenefitEnumFR[]): OperationBenefitEnum[] => {
  const OperationBenefitEnums: OperationBenefitEnum[] = [];
  a.forEach(e => {
    OperationBenefitEnums.push(getOperationBenefitFromFR(e));
  });
  return OperationBenefitEnums;
};

export const getOperationBenefitArrayFromEN = (a: OperationBenefitEnum[]): OperationBenefitEnumFR[] => {
  return a.map(e => {
    return getOperationBenefitFromEN(e);
  });
};
